<template>
    <font-awesome-icon class="fa-fw" :icon="['fal', 'times']" />
</template>

<script>
    export default {
        name: "Deselect"
    }
</script>

<style lang="scss" scoped>
    .fa-fw {
        path {
            fill: #4d4d4d;
        }
    }
</style>